export default __webpack_public_path__ + "static/media/ChaltenUso20.15a46fdc.jpeg";